import { createReducer } from '@reduxjs/toolkit';
import { getAllLanguagesAction } from './actions';

const initialState = {
  list: [],
};

export default createReducer(initialState, builder =>
  builder.addCase(getAllLanguagesAction, (state, action) => {
    state.list = action.payload;
  })
);
